import React, { useCallback } from 'react'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import { TourV2ContentSections } from 'constants/tours'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'

interface Props {
  purchasableOption?: Tours.TourV2OfferPurchasableOption
  onScrollTo: (section: TourV2ContentSections) => void
  visible: boolean;
}

function TourV2StickyFooter(props: Props) {
  const { purchasableOption, onScrollTo, visible } = props

  const purchasableOptionDetails = useTourV2PurchasableOptionDetails(purchasableOption)

  const scrollToDepartures = useCallback(
    () => {
      onScrollTo(TourV2ContentSections.DEPARTURES)
    },
    [onScrollTo],
  )

  return (
    <OfferPageStickyFooter visible={visible} callToActionCopy="Check Availability" onCTAClick={scrollToDepartures}>
      {!!purchasableOptionDetails && <div>
        <PriceRowPriceWithCaption
            size="M"
            caption="From"
            price={purchasableOptionDetails.pricePerPerson}
            saleUnit="person"
          />
        <PriceRowCaption>
          {purchasableOptionDetails.roomTypeName}
        </PriceRowCaption>
      </div>}
    </OfferPageStickyFooter>
  )
}

export default TourV2StickyFooter
